import axios from 'axios';

export default {
    async createLocation(dataParams) {
        return axios.post(`api/locations`, dataParams);
    },
    async updateLocation(locationId, dataParams) {
        return axios.put(`api/locations/${locationId}`, dataParams);
    },
    async deleteLocation(locationId) {
        return axios.delete(`api/locations/${locationId}`);
    }
};
